export const UNASSIGNED_ROOMS_TAB_ID = "unassigned-rooms"
export const UNASSIGNED_PRODUCTS_TAB_ID = "unassigned-products"
